export const MAX_NUMBER_LIMIT = 999999;
